import $ from "jquery";
import "jquery-mask-plugin/dist/jquery.mask.min.js";
import React from "react";
import { Button, Form, Alert, Modal, Table } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";

export default class AddPhysicianmodal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formValidated: false,
      findFormValidated: false,
      states: [],
      showBrightreeDoctorsModal: false,
      brightreeDoctors: [],
      isLoadingBrightreeDoctors: false,
      PhysicianFind: {
        firstName: "",
        lastName: "",
        npi: "",
      },

      Physician: {
        physicianId: 0,
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        suffix: "",
        physicianNote: "",
        npi: "",
        stateMedicaidId: "",
        licenseNo: "",
        TaxonomyCode: "",
        brightreeId: 0,
        doctorGroupId: 0,

        address: {
          addressId: 0,
          addressLine1: "",
          addressLine2: "",
          city: "",
          sateId: 1,
          countryId: 1,
          zip: "",
          phone1: "",
          email: "",
          mobile1: "",
          fax: "",
        },
      },
    };
    this.findForm = React.createRef();
  }

  componentDidMount() {
    $("#Phone1").mask("000-000-0000");
    $("#Mobile1").mask("000-000-0000");
    $("#Fax").mask("000-000-0000");

    $("#Phone1").change((e) => {
      Common.updateInputValueInState(
        this.state.Physician.address,
        e,
        this,
        this.state
      );
    });
    $("#Mobile1").change((e) => {
      Common.updateInputValueInState(
        this.state.Physician.address,
        e,
        this,
        this.state
      );
    });
    $("#Fax").change((e) => {
      Common.updateInputValueInState(
        this.state.Physician.address,
        e,
        this,
        this.state
      );
    });

    this.getAllState();
    
    // If physician prop is provided, populate the form for editing
    if (this.props.physician) {
      this.populatePhysicianData(this.props.physician);
    }
  }

  componentDidUpdate(prevProps) {
    // If physician prop changes, update the form
    if (this.props.physician && this.props.physician !== prevProps.physician) {
      this.populatePhysicianData(this.props.physician);
    }
  }

  populatePhysicianData = (physician) => {
    // Log to check if brightreeId is in the physician object
    console.log("Populating physician data:", physician);
    console.log("brightreeId value:", physician.brightreeId);
    
    let physicianData = {
      physicianId: physician.physicianId || 0,
      title: physician.title || "",
      firstName: physician.firstName || "",
      middleName: physician.middleName || "",
      lastName: physician.lastName || "",
      suffix: physician.suffix || "",
      physicianNote: physician.physicianNote || "",
      npi: physician.npi || "",
      stateMedicaidId: physician.stateMedicaidId || "",
      licenseNo: physician.licenseNo || "",
      TaxonomyCode: physician.taxonomyCode || physician.TaxonomyCode || "",
      brightreeId: physician.brightreeId || physician.BrightreeId || 0,
      doctorGroupId: physician.doctorGroupId || 0,
      address: {
        addressId: physician.address?.addressId || 0,
        addressLine1: physician.address?.addressLine1 || "",
        addressLine2: physician.address?.addressLine2 || "",
        city: physician.address?.city || "",
        sateId: physician.address?.sateId || physician.address?.stateId || 1,
        countryId: physician.address?.countryId || 1,
        zip: physician.address?.zip || "",
        phone1: physician.address?.phone1 || "",
        email: physician.address?.email || "",
        mobile1: physician.address?.mobile1 || "",
        fax: physician.address?.fax || "",
      },
    };

    this.setState({ Physician: physicianData });
  }

  handleFindSubmit = (e) => {
    if (this.findForm.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      let _state = this.state;
      _state.findFormValidated = true;
      this.setState(_state);
    } else {
      // if successfull validation
      const {
        firstName: FirstName,
        lastName: LastName,
        npi: Npi,
      } = this.state.PhysicianFind;
      Api.getRequest(
        `${Api.apiUrls.searcDoctors}?lastName=${LastName}&firstName=${FirstName}&npi=${Npi}`,
        false
      )
        .then((res) => {
          
          if (res.data.success) {
            if (res.data.result != null) {
              Common.showSuccessAlertAutoClose(
                "Physician got Successfully",
                "success",
                "Success!",
                3000
              );
              var nonNulls = Object.entries(res.data.result)
                .filter(([name, value]) => value !== null)
                .map(([name, value]) => ({ name, value }));
              let r = this.state.Physician;
              nonNulls.forEach((element) => {
                r[element.name] = element.value;
              });

              this.setState({
                Physician: r,
              });
              // this.props.close();
            } else {
              Common.showSuccessAlertAutoClose(
                res.data.message,
                "warning",
                "Failed!",
                3000
              );
            }
          } else {
            Common.showSuccessAlertAutoClose(
              "No data found against given criteria",
              "warning",
              "Failed!",
              3000
            );
          }
        })
        .catch((ex) => {
          
          Common.showSuccessAlertAutoClose(
            "some error occured while processing your request",
            "warning",
            "Failed!",
            3000
          );
          // api call
          // on response
        });
    }
    // prepare payload
  };

  render() {
    const isEditMode = this.props.physician && this.props.physician.physicianId;
    
    return (
      <>
        {!isEditMode && (
          <Form ref={this.findForm} validated={this.state.findFormValidated}>
            <Card className="">
              <CardHeader title="Search Physician" />
              <CardBody>
                <Alert className="mb-5" variant="secondary">
                  Fill in one or more fields to search physician.
                </Alert>

                <div className="row">
                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label className="form-label" htmlFor="LastName">
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="LastName"
                        name="lastName"
                        required
                        onChange={(e) =>
                          Common.updateInputValueInState(
                            this.state.PhysicianFind,
                            e,
                            this,
                            this.state
                          )
                        }
                        className="form-control form-control-sm"
                      />
                      <div className="invalid-feedback">
                        Last Name Is Required
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label className="form-label" htmlFor="FirstName">
                        First Name
                      </label>
                      <input
                        type="text"
                        id="FirstName"
                        name="firstName"
                        onChange={(e) =>
                          Common.updateInputValueInState(
                            this.state.PhysicianFind,
                            e,
                            this,
                            this.state
                          )
                        }
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label className="form-label" htmlFor="NPI">
                        NPI
                      </label>
                      <input
                        type="text"
                        id="NPI"
                        name="npi"
                        onChange={(e) =>
                          Common.updateInputValueInState(
                            this.state.PhysicianFind,
                            e,
                            this,
                            this.state
                          )
                        }
                        className="form-control form-control-sm"
                      />
                    </div>
                  </div>
                </div>
              </CardBody>
              <CardFooter className="d-flex justify-content-end py-3">
                <Button
                  variant="success"
                  className="mr-5 px-10"
                  size="sm"
                  onClick={(e) => this.handleFindSubmit(e)}
                >
                  Find
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => this.props.close()}
                >
                  Cancel
                </Button>
              </CardFooter>
            </Card>
          </Form>
        )}

        <Form validated={this.state.formValidated}>
          <Card className="">
            <CardHeader title={this.props.physician?.physicianId ? "Edit Physician" : "New Physician"} />
            <CardBody>
              <>
                <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                  <legend className="text-primary fw-500">
                    Basic Information{" "}
                  </legend>
                  <div className="row">
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="SSN">
                          Pro Designations
                        </label>
                        <input
                          type="text"
                          id="Title"
                          name="title"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.title ?? ""}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3 col-xl-2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="LastName">
                          Last Name
                        </label>
                        <input
                          type="text"
                          id="LastName"
                          name="lastName"
                          required
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.lastName ?? ""}
                          className="form-control form-control-sm"
                        />
                        <div className="invalid-feedback">
                          Last Name Is Required
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3 col-xl-2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="FirstName">
                          First Name
                        </label>
                        <input
                          type="text"
                          id="FirstName"
                          name="firstName"
                          required
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.firstName ?? ""}
                          className="form-control form-control-sm"
                        />
                        <div className="invalid-feedback">
                          First Name Is Required
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3 col-md-3 col-lg-3 col-xl-2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="FirstName">
                          Middle Name
                        </label>
                        <input
                          type="text"
                          id="MiddleName"
                          name="middleName"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.middleName ?? ""}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="suffix">
                          Suffix
                        </label>
                        <input
                          type="Suffix"
                          id="suffix"
                          name="suffix"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.suffix ?? ""}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Status">
                          Doctor Group
                        </label>
                        <select
                          defaultValue={
                            this.state.Physician.doctorGroupId ?? ""
                          }
                          className="form-control form-control-sm"
                          id="DoctorGroupID"
                          name="doctorGroupId"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                        >
                          <option value="0">Select Doctor Group</option>
                          <option value="100">Cardiologist</option>
                          <option value="105">Endocrinologist</option>
                          <option value="101">General Practice</option>
                          <option value="102">Internal Medicine</option>
                          <option value="106">Oncologist</option>
                          <option value="104">Orthopedics</option>
                          <option value="103">Pulmonologist</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6 col-xl-12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="State">
                          Memo
                        </label>
                        <textarea
                          id="Note"
                          rows="3"
                          className="form-control"
                          name="physicianNote"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={
                            this.state.Physician.physicianNote ?? ""
                          }
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>

                <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                  <legend className="text-primary fw-500">
                    Address Information
                  </legend>
                  <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="State">
                          Address Line 1
                        </label>
                        <input
                          id="address1"
                          name="address.addressLine1"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={
                            this.state.Physician.address?.addressLine1 ?? ""
                          }
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="State">
                          Address Line 2
                        </label>
                        <input
                          id="address1"
                          name="address.addressLine2"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={
                            this.state.Physician.address?.addressLine2 ?? ""
                          }
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="City">
                          City
                        </label>
                        <input
                          type="text"
                          id="City"
                          name="address.city"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          // defaultValue={
                          //   this.state.Physician.address?.city ?? ""
                          // }
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="State">
                          State
                        </label>
                        <select
                          defaultValue={
                            this.state.Physician.address?.stateId ?? ""
                          }
                          className="form-control form-control-sm"
                          name="address.stateId"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                        >
                          <option></option>
                          {this.setAllState(this.state.states)}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Country">
                          Country
                        </label>
                        <select
                          // defaultValue={
                          //   this.state.Physician.address?.countryId ?? ""
                          // }
                          className="form-control form-control-sm"
                          name="address.countryId"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          id="Country"
                        >
                          <option value="1">United States</option>
                          <option value="2">Canada</option>
                          <option value="3">Mexico</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-3 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Zip">
                          Postal code
                        </label>
                        <input
                          type="text"
                          id="Zip"
                          name="address.zip"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.address?.zip ?? ""}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Phone1">
                          Telephone
                        </label>
                        <input
                          type="text"
                          id="Phone1"
                          name="address.phone1"
                          required
                          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={
                            this.state.Physician.address?.phone1 ?? ""
                          }
                          className="form-control form-control-sm"
                        />
                        <small>nnn-nnn-nnnn or nnnnnnnnnn</small>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Mobile1">
                          Mobile
                        </label>
                        <input
                          type="text"
                          id="Mobile1"
                          name="address.mobile1"
                          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          // defaultValue={
                          //   this.state.Physician.address?.mobile1 ?? ""
                          // }
                          className="form-control form-control-sm"
                        />
                        <small>nnn-nnn-nnnn or nnnnnnnnnn</small>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Fax">
                          Fax
                        </label>
                        <input
                          type="text"
                          id="Fax"
                          name="address.fax"
                          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.address?.fax ?? ""}
                          className="form-control form-control-sm"
                        />
                        <small>nnn-nnn-nnnn or nnnnnnnnnn</small>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="Email">
                          Email
                        </label>
                        <input
                          type="text"
                          id="Email"
                          name="address.email"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician.address,
                              e,
                              this,
                              this.state
                            )
                          }
                          // defaultValue={
                          //   this.state.Physician.address?.email ?? ""
                          // }
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    {/* End Address */}
                  </div>
                </fieldset>

                <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                  <legend className="text-primary fw-500">
                    Medical Information{" "}
                  </legend>
                  <div className="row">
                    <div className="col-sm-5 col-md-3 col-lg-3 col-xl-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="LicenseNo">
                          License No
                        </label>
                        <input
                          type="text"
                          id="LicenseNo"
                          name="licenseNo"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.licenseNo ?? ""}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-5 col-md-3 col-lg-3 col-xl-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="NPI">
                          NPI
                        </label>
                        <input
                          type="text"
                          id="NPI"
                          name="npi"
                          required
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.npi ?? ""}
                          className="form-control form-control-sm"
                        />
                        <div className="invalid-feedback">NPI Is Required</div>
                      </div>
                    </div>
                    <div className="col-sm-5 col-md-3 col-lg-3 col-xl-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="TaxonomyCode">
                          Taxonomy Code
                        </label>
                        <input
                          type="text"
                          id="TaxonomyCode"
                          name="taxonomyCode"
                          onChange={(e) =>
                            Common.updateInputValueInState(
                              this.state.Physician,
                              e,
                              this,
                              this.state
                            )
                          }
                          defaultValue={this.state.Physician.taxonomyCode ?? ""}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                    <div className="col-sm-5 col-md-3 col-lg-3 col-xl-4">
                      <div className="form-group">
                        <label className="form-label" htmlFor="BrightreeId">
                          Brightree ID
                        </label>
                        <div className="d-flex">
                          <input
                            type="text"
                            id="BrightreeId"
                            name="brightreeId"
                            onChange={(e) =>
                              Common.updateInputValueInState(
                                this.state.Physician,
                                e,
                                this,
                                this.state
                              )
                            }
                            value={this.state.Physician.brightreeId && this.state.Physician.brightreeId !== 0 && this.state.Physician.brightreeId !== "0" ? String(this.state.Physician.brightreeId) : ""}
                            className="form-control form-control-sm"
                            placeholder="Enter Brightree ID"
                            readOnly={this.props.physician?.physicianId ? true : false}
                          />
                          {this.props.physician?.physicianId && (
                            (() => {
                              const npi = this.state.Physician.npi || "";
                              const normalizedNpi = String(npi).replace(/\D/g, "");
                              const hasValidNpi = normalizedNpi.length === 10;
                              const hasName = (this.state.Physician.firstName || "").trim() || (this.state.Physician.lastName || "").trim();
                              return hasValidNpi || hasName;
                            })() && (
                              <Button
                                variant="info"
                                size="sm"
                                className="ml-2"
                                onClick={() => this.handleSearchBrightreeDoctors()}
                                disabled={this.state.isLoadingBrightreeDoctors}
                              >
                                {this.state.isLoadingBrightreeDoctors ? "Searching..." : "Search BT"}
                              </Button>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                    {/* End Address */}
                  </div>
                </fieldset>
              </>
            </CardBody>
            <CardFooter className="d-flex justify-content-end py-3">
              <Button
                variant="success"
                className="mr-5 px-10"
                size="sm"
                onClick={(e) => this.handleSubmit(e)}
              >
                Save
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={() => this.props.close()}
              >
                Cancel
              </Button>
            </CardFooter>
          </Card>
        </Form>

        {/* Brightree Doctors Selection Modal */}
        <Modal
          show={this.state.showBrightreeDoctorsModal}
          onHide={this.handleCloseBrightreeDoctorsModal}
          size="lg"
          centered
          scrollable
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Brightree Doctor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.brightreeDoctors.length > 0 ? (
              <Table striped bordered hover responsive size="sm">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Name</th>
                    <th>Pro Designations</th>
                    <th>Telephone #</th>
                    <th>Email</th>
                    <th>NPI #</th>
                    <th>Brightree ID</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.brightreeDoctors.map((doctor, index) => (
                    <tr key={doctor.physicianId || index}>
                      <td>
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => this.handleSelectBrightreeDoctor(doctor)}
                        >
                          Select
                        </Button>
                      </td>
                      <td>
                        {Common.replaceNullWithString(doctor.lastName) + " " + Common.replaceNullWithString(doctor.firstName)}
                      </td>
                      <td>{Common.replaceNullWithString(doctor.title) || "N/A"}</td>
                      <td>{Common.replaceNullWithString(doctor.address?.phone1) || "N/A"}</td>
                      <td>{Common.replaceNullWithString(doctor.address?.email) || "N/A"}</td>
                      <td>{Common.replaceNullWithString(doctor.npi) || "N/A"}</td>
                      <td>{doctor.brightreeId || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Alert variant="info">No Brightree doctors found for this NPI.</Alert>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseBrightreeDoctorsModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  //Functions

  //#region Get States
  getAllState() {
    Api.getRequest(Api.Uri_GetState)
      .then((res) => {
        if (res.data.statusCode == 200) {
          if (res.data.result != null) {
            if (res.data.result.length > 0) {
              this.setState({ states: res.data.result });
            }
          }
        }
      })
      .catch((ex) => {});
  }

  setAllState(states) {
    return states.map((state) => (
      <option key={state.key} value={state.key}>
        {state.value}
      </option>
    ));
  }
  //#endregion

  //#region Brightree Doctors Search
  handleSearchBrightreeDoctors = () => {
    // Normalize NPI to digits only
    const rawNpi = this.state.Physician.npi || "";
    const normalizedNpi = String(rawNpi).replace(/\D/g, "");
    
    // Get firstName and lastName, trim whitespace - preserve actual values
    const rawFirstName = this.state.Physician.firstName;
    const rawLastName = this.state.Physician.lastName;
    const firstName = rawFirstName ? String(rawFirstName).trim() : "";
    const lastName = rawLastName ? String(rawLastName).trim() : "";
    
    // Debug logging before processing
    console.log("Raw state values - firstName:", rawFirstName, "lastName:", rawLastName);
    console.log("Processed values - firstName:", firstName, "lastName:", lastName, "normalizedNpi:", normalizedNpi);
    
    // Prefer NPI if valid (10 digits); otherwise require at least one name field
    const useNpi = normalizedNpi && normalizedNpi.length === 10;
    if (!useNpi && !firstName && !lastName) {
      Common.showSuccessAlertAutoClose(
        "Please enter a valid 10-digit NPI, or at least First Name or Last Name to search Brightree doctors",
        "warning",
        "Invalid Search Criteria",
        3000
      );
      return;
    }

    this.setState({ isLoadingBrightreeDoctors: true, brightreeDoctors: [] });
    
    // Prepare the request payload matching PhySearchReqModel
    // Property names must be PascalCase: NPI, FirstName, LastName
    // NPI should be sent as a number (long) - use Number() to ensure proper conversion for all 10-digit values
    // JavaScript numbers can safely represent integers up to 2^53-1, so 10-digit numbers are safe
    const requestPayload = {
      NPI: useNpi ? Number(normalizedNpi) : null,
      FirstName: useNpi ? null : (firstName || null),
      LastName: useNpi ? null : (lastName || null),
    };
    
    // Debug logging to see what's being sent
    console.log("SearchBTDoctors request payload:", JSON.stringify(requestPayload, null, 2));
    console.log("useNpi:", useNpi, "firstName:", firstName, "lastName:", lastName);
    
    // Send as POST with [FromBody] - payload in request body
    Api.postRequest(Api.URI_SearchBTDoctors, requestPayload)
      .then((res) => {
        // Handle different response structures
        let doctors = [];
        
        // Check if response has the expected structure
        if (res && res.data) {
          // Case 1: Standard response with statusCode and result
          if (res.data.statusCode == 200 || res.data.success) {
            doctors = res.data.result || [];
          }
          // Case 2: Response might have result directly as an array
          else if (Array.isArray(res.data.result)) {
            doctors = res.data.result;
          }
          // Case 3: Response data might be the array directly
          else if (Array.isArray(res.data)) {
            doctors = res.data;
          }
          // Case 4: Check if result exists but statusCode/success is missing
          else if (res.data.result !== null && res.data.result !== undefined) {
            doctors = Array.isArray(res.data.result) ? res.data.result : [];
          }
        }
        
        // If we got doctors, show the modal
        if (doctors.length > 0 || (res && res.data && (res.data.statusCode == 200 || res.data.success))) {
          this.setState({ 
            brightreeDoctors: doctors,
            showBrightreeDoctorsModal: true 
          });
          if (doctors.length === 0) {
            Common.showSuccessAlertAutoClose(
              "No Brightree doctors found for this NPI",
              "info",
              "No Results",
              3000
            );
          }
        } else {
          // Only show error if we didn't get a successful response
          const errorMessage = res?.data?.message || "Failed to search Brightree doctors";
          Common.showSuccessAlertAutoClose(
            errorMessage,
            "warning",
            "Error",
            3000
          );
        }
      })
      .catch((ex) => {
        // Log the actual error for debugging
        console.error("Error searching Brightree doctors:", ex);
        console.error("Error response:", ex?.response?.data);
        
        // Check if it's a response error with a message
        const errorMessage = ex?.response?.data?.message 
          || ex?.message 
          || "Some error occurred while searching Brightree doctors";
        
        Common.showSuccessAlertAutoClose(
          errorMessage,
          "warning",
          "Error",
          3000
        );
      })
      .finally(() => {
        this.setState({ isLoadingBrightreeDoctors: false });
      });
  };

  handleSelectBrightreeDoctor = (doctor) => {
    // Populate all physician fields from the selected Brightree doctor
    // Preserve physicianId and addressId if in edit mode
    let updatedPhysician = { ...this.state.Physician };
    
    // Update basic information - use doctor's values if available, otherwise keep existing
    updatedPhysician.title = doctor.title || "";
    updatedPhysician.firstName = doctor.firstName || "";
    updatedPhysician.middleName = doctor.middleName || "";
    updatedPhysician.lastName = doctor.lastName || "";
    updatedPhysician.suffix = doctor.suffix || "";
    updatedPhysician.npi = doctor.npi || "";
    updatedPhysician.brightreeId = doctor.brightreeId || doctor.BrightreeId || 0;
    updatedPhysician.licenseNo = doctor.licenseNo || "";
    updatedPhysician.taxonomyCode = doctor.taxonomyCode || doctor.TaxonomyCode || "";
    updatedPhysician.stateMedicaidId = doctor.stateMedicaidId || "";
    updatedPhysician.physicianNote = doctor.physicianNote || "";
    updatedPhysician.doctorGroupId = doctor.doctorGroupId || 0;
    
    // Preserve physicianId (don't overwrite it when editing)
    // updatedPhysician.physicianId remains unchanged
    
    // Update address information if available
    if (doctor.address) {
      // Preserve addressId if it exists (for edit mode)
      const existingAddressId = updatedPhysician.address?.addressId || 0;
      
      updatedPhysician.address = {
        addressId: existingAddressId, // Preserve existing addressId
        addressLine1: doctor.address.addressLine1 || "",
        addressLine2: doctor.address.addressLine2 || "",
        city: doctor.address.city || "",
        sateId: doctor.address.stateId || doctor.address.sateId || 1,
        countryId: doctor.address.countryId || 1,
        zip: doctor.address.zip || "",
        phone1: doctor.address.phone1 || "",
        email: doctor.address.email || "",
        mobile1: doctor.address.mobile1 || "",
        fax: doctor.address.fax || "",
      };
    }
    
    this.setState({ 
      Physician: updatedPhysician,
      showBrightreeDoctorsModal: false 
    });
    Common.showSuccessAlertAutoClose(
      "Physician data updated successfully from Brightree",
      "success",
      "Success",
      2000
    );
  };

  handleCloseBrightreeDoctorsModal = () => {
    this.setState({ showBrightreeDoctorsModal: false });
  };
  //#endregion

  handleSubmit = (event) => {
    
    const form = event.currentTarget.form;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      let _state = this.state;
      _state.formValidated = true;
      this.setState(_state);
    } else {
      this.URI_UpsertPhysician();
    }
  };

  URI_UpsertPhysician() {
    let obj = this.state.Physician;
    if (obj.address != null) {
      obj.address.phone1 =
        Common.replaceNullWithString(obj.address.phone1) != ""
          ? obj.address.phone1.replace(/\D/g, "")
          : null;
      obj.address.mobile1 =
        Common.replaceNullWithString(obj.address.mobile1) != ""
          ? obj.address.mobile1.replace(/\D/g, "")
          : null;
      obj.address.fax =
        Common.replaceNullWithString(obj.address.fax) != ""
          ? obj.address.fax.replace(/\D/g, "")
          : null;
    }

    // Convert brightreeId to number if it's a string
    if (obj.brightreeId !== null && obj.brightreeId !== undefined && obj.brightreeId !== "") {
      obj.brightreeId = parseInt(obj.brightreeId) || 0;
    } else {
      obj.brightreeId = 0;
    }
    
    Api.postRequest(Api.URI_UpsertPhysician, obj)
      .then((res) => {
        
        if (res.data.success) {
          if (res.data.result != null) {
            Common.showSuccessAlertAutoClose(
              "Physician Created Successfully",
              "success",
              "Success!",
              3000
            );
            this.props.close();
          } else {
            Common.showSuccessAlertAutoClose(
              res.data.message,
              "warning",
              "Failed!",
              3000
            );
          }
        } else {
          Common.showSuccessAlertAutoClose(
            res.data.message,
            "warning",
            "Failed!",
            3000
          );
        }
      })
      .catch((ex) => {
        
        Common.showSuccessAlertAutoClose(
          "some error occured while processing your request",
          "warning",
          "Failed!",
          3000
        );
      });
  }
} //end of class
